/*!
 * KoliBri - The accessible HTML-Standard
 */
import { e as watchBoolean } from './common-D-vggmh2.js';

const validateReadOnly = (component, value) => {
    watchBoolean(component, '_readOnly', value);
};

export { validateReadOnly as v };
//# sourceMappingURL=read-only-DyDY-E9H.js.map

//# sourceMappingURL=read-only-DyDY-E9H.js.map